import React from 'react'

interface ITimelineItemProps {
    index: number,
    content: any
}

export const TimelineItem: React.FC<ITimelineItemProps> = ({index, content}) => {
    let positioning: string = index % 2 === 1 ? "timeline-panel-left" : "timeline-panel-right"

    return (
        <li className="">
            <div className="">
                <img className="custom-circle-img rounded-circle" src={content.image} alt="timeline row"/>
            </div>

            <div className={ positioning + " py-3"}>
                <div className="">
                    <h4 className="">{content.daterange}</h4>
                    {(content.heading) && <h5 className="">{content.heading}</h5>}
                </div>
                
                <div className="">
                    <div className="font-description">
                        {/* Yup this is bad */}
                        <div dangerouslySetInnerHTML={ {__html: content.paragraph} } />
                    </div>
                </div>
            </div>
        </li>
    )
}

export default TimelineItem;